import React from 'react';
import OneVisualLayout from "../../layouts/one-visual";

import Image from '../../../../containers/assets/pf3.png';

const GoodLuckStep1 = () => (
  <OneVisualLayout
    section="GOOD LUCK!"
    title="See You in the Next Round"
    paragraph2={(
      <span>
        Expect a few changes next year based on current market performance.
      </span>
    )}
    visual={(
      <img src={Image} alt="preview" />
    )}
    visualProps={{
      noBorder: true,
      noBackground: true,
    }}
  />
);

export default GoodLuckStep1;



// WEBPACK FOOTER //
// ./src/components/performance-feedback/pages/good-luck/step1.js